import type { AppFlowsContainer } from '#flows.js';
import type { DestinationsContainer } from './DestinationsContainer.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientTripModel } from '#models/TripModel.js';

export function createTripsContainer(
  flows: AppFlowsContainer,
  firestore: FirestoreContainer,
  destinations: DestinationsContainer,
) {
  const $trips = createContainer('trips').providedLazy('ClientTrip', () =>
    createClientTripModel(flows, firestore, destinations),
  );
  return $trips;
}

export type $TripsContainer = ReturnType<typeof createTripsContainer>;
export type TripsContainer = $TripsContainer['use'];
